import { render, staticRenderFns } from "./QuantityLimits.vue?vue&type=template&id=4d4b57d1&"
import script from "./QuantityLimits.vue?vue&type=script&lang=ts&"
export * from "./QuantityLimits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports